document.addEventListener('DOMContentLoaded', () => {
  const modal = document.getElementById('ca-viewer-modal');
  const viewport = document.getElementById('ca-viewer-viewport');
  const modalImage = document.getElementById('ca-viewer-image');
  const closeBtn = document.getElementById('ca-viewer-close');
  const zoomInBtn = document.getElementById('ca-zoom-in');
  const zoomOutBtn = document.getElementById('ca-zoom-out');
  const prevBtn = document.getElementById('ca-nav-prev');
  const nextBtn = document.getElementById('ca-nav-next');
  const thumbsContainer = document.getElementById('ca-viewer-thumbnails');

  let gallery = [];
  let currentIndex = 0;
  let isZoomed = false;

  function collectPageImages() {
    gallery = [];
    const elements = document.querySelectorAll(
      '.thumbnail-list__item img, .product__media-list .product__media img'
    );
    const set = new Set();
    elements.forEach((img) => {
      const src = (img.currentSrc || img.src || '').replace(/&width=\d+/g, '');
      if (src && !set.has(src)) {
        set.add(src);
        gallery.push(src);
      }
    });
  }

  function renderVerticalThumbnails() {
    if (!thumbsContainer) return;
    thumbsContainer.innerHTML = '';

    gallery.forEach((src, idx) => {
      const thumb = document.createElement('img');
      thumb.src = src + '&width=140';
      thumb.classList.add('ca-vthumb');
      if (idx === currentIndex) thumb.classList.add('active');

      thumb.addEventListener('click', (e) => {
        e.stopPropagation();
        switchImage(idx);
      });

      thumbsContainer.appendChild(thumb);
    });
  }

  function updateActiveThumbnail() {
    const thumbs = thumbsContainer.querySelectorAll('.ca-vthumb');
    thumbs.forEach((t, i) => {
      t.classList.toggle('active', i === currentIndex);
    });
  }

  function resetZoom() {
    isZoomed = false;
    viewport.classList.remove('is-zoomed');
    modalImage.style.transform = 'translate3d(0px, 0px, 0px)';
  }

  function setZoom(state) {
    isZoomed = state;
    if (isZoomed) {
      viewport.classList.add('is-zoomed');
    } else {
      resetZoom();
    }
  }

  function switchImage(index) {
    if (index < 0) index = gallery.length - 1;
    if (index >= gallery.length) index = 0;
    currentIndex = index;

    resetZoom();
    modalImage.src = gallery[currentIndex];
    updateActiveThumbnail();
  }

  window.openCAViewer = function(selectedSrc) {
    if (!modal || !modalImage) return;

    collectPageImages();
    const cleanSrc = (selectedSrc || '').replace(/&width=\d+/g, '');
    const foundIndex = gallery.indexOf(cleanSrc);
    currentIndex = foundIndex !== -1 ? foundIndex : 0;

    renderVerticalThumbnails();
    switchImage(currentIndex);

    modal.classList.add('ca-viewer-active');
    modal.setAttribute('aria-hidden', 'false');
  };

  function closeCAViewer() {
    if (!modal) return;
    modal.classList.remove('ca-viewer-active');
    modal.setAttribute('aria-hidden', 'true');
    resetZoom();
  }

  // Click strictly on the modal image element to toggle zoom
  modalImage.addEventListener('click', (e) => {
    e.stopPropagation();
    setZoom(!isZoomed);
  });

  // Track cursor movement strictly within the physical boundaries of the image
  modalImage.addEventListener('mousemove', (e) => {
    if (!isZoomed) return;

    const rect = modalImage.getBoundingClientRect();
    
    if (
      e.clientX < rect.left ||
      e.clientX > rect.right ||
      e.clientY < rect.top ||
      e.clientY > rect.bottom
    ) {
      return;
    }

    const mouseY = e.clientY - rect.top;
    const percentageY = (mouseY / rect.height) - 0.5;

    const maxOffset = window.innerHeight * 0.35;
    const translateY = -percentageY * (maxOffset * 2);

    modalImage.style.transform = `translate3d(0px, ${translateY}px, 0px)`;
  });

  // Reset zoom when clicking empty viewport area
  viewport.addEventListener('click', (e) => {
    if (e.target !== modalImage && isZoomed) {
      resetZoom();
    }
  });

  // Header controls
  zoomInBtn.addEventListener('click', (e) => {
    e.stopPropagation();
    setZoom(true);
  });

  zoomOutBtn.addEventListener('click', (e) => {
    e.stopPropagation();
    setZoom(false);
  });

  // Arrow navigation
  nextBtn.addEventListener('click', (e) => {
    e.stopPropagation();
    switchImage(currentIndex + 1);
  });

  prevBtn.addEventListener('click', (e) => {
    e.stopPropagation();
    switchImage(currentIndex - 1);
  });

  // Close bindings
  closeBtn.addEventListener('click', closeCAViewer);
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && modal.classList.contains('ca-viewer-active')) {
      closeCAViewer();
    }
    if (modal.classList.contains('ca-viewer-active')) {
      if (e.key === 'ArrowRight') switchImage(currentIndex + 1);
      if (e.key === 'ArrowLeft') switchImage(currentIndex - 1);
    }
  });

  // Intercept ONLY main product image clicks (allow thumbnail list to switch images natively)
  document.addEventListener('click', (e) => {
    // If the click is inside the thumbnail list/strip on the page, let Dawn switch the main image
    if (e.target.closest('.thumbnail') || e.target.closest('.thumbnail-list__item')) {
      return;
    }

    // Only open the full-screen CA-Previewer when clicking the main active image container
    const mainImgClick = e.target.closest('modal-opener');
    if (mainImgClick) {
      e.preventDefault();
      e.stopPropagation();
      const img = mainImgClick.querySelector('img');
      if (img) window.openCAViewer(img.currentSrc || img.src);
    }
  }, true);
});